import { all, takeLatest, put, call } from 'redux-saga/effects';
import { createList } from 'yoda-interfaces/lib/MyList/MyList';
import FSaga from 'yoda-site-components/lib/sagas/FactorySaga';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import * as MyListActionTypes from '../actionTypes/MyListActionTypes';

function sortByName(userList) {
    const [first, ...rdata] = userList;
    rdata.sort(({ name: a }, { name: b }) => {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    });
    return [first, ...rdata];
}

export function* createListSaga(action) {
    const response = yield call(FSaga, createList, action, undefined, false);
    const payload = {
        response: response.data || response.response.data,
    };
    payload.isLoading = false;
    payload.requestFrom = 'POST';
    try {
        if (response.response.status === 201 || response.status === 201) {
            payload.isSuccess = true;
            const createdItem = payload.response;
            // Add new list to Token Provider
            try {
                let userList = JSON.parse(TokenProvider.get('DP_USER_LIST'));
                userList.push({
                    id: createdItem.id,
                    name: createdItem.name,
                });
                userList = sortByName(userList);
                TokenProvider.set('DP_USER_LIST', JSON.stringify(userList));
                TokenProvider.set('DP_USER_NEW_MY_LIST', JSON.stringify({ id: createdItem.id }));
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log('Some error');
            }
            yield all([
                put({ type: MyListActionTypes.CREATE_MY_LIST_REQ_COMPLETED }),
                put({ type: MyListActionTypes.TRACK_MY_LIST_CREATED, payload }),
                put({ type: MyListActionTypes.CREATE_MY_LIST_SUCCESS, payload }),
            ]);
        } else {
            payload.isSuccess = false;

            const eventObject = [];
            eventObject.push({
                errorID: payload.response.errorCode,
                errorCategory: '',
                errorDescription: payload.response.errorMessage,
            });
            const formError = { payload: eventObject };
            yield all([
                put({ type: MyListActionTypes.CREATE_MY_LIST_REQ_COMPLETED }),
                put({ type: MyListActionTypes.CREATE_MY_LIST_FAILURE, payload }),
                put({ type: MyListActionTypes.TRACK_MY_LIST_FORM_ERROR, formError }),
            ]);
        }
    } catch (error) {
        const errorPayload = {
            response: {
                errorMessage: error.message,
                errorCode: 'EXCEPTION_IN_CREATE_LIST_SAGA',
            },
            isSuccess: false,
        };
        yield all([
            put({ type: MyListActionTypes.CREATE_MY_LIST_REQ_COMPLETED }),
            put({ type: MyListActionTypes.CREATE_MY_LIST_FAILURE, payload: errorPayload }),
        ]);
    }
}

const watchMyListSaga = function* watchMyListSaga() {
    yield takeLatest(MyListActionTypes.CREATE_MY_LIST, createListSaga);
};

watchMyListSaga.sagaName = 'myListSaga';

export default watchMyListSaga;
